import React from "react";
import Skeleton from "react-loading-skeleton";
import { View } from "react-native";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import Skeletons from "./Skeletons";
import { AppColors } from "../../utility/AppColors";
import { s } from "react-native-size-matters";

const UserListingSkeleton = ({ size }) => {
  const deviceSize = useDeviceSize();
  let skeletonCards = Array(size).fill(0);
  return (
    <View
      style={{
        flexDirection: "column",
        width: "50%",
        gap: 10,
        paddingTop: 12,
        paddingBottom: 35,
      }}
    >
      <Skeletons
        height={20}
        width={"70px"}
        style={{
          borderRadius: 10,
        }}
      />
      <View
        style={{
          flexDirection: "row",
          width: "50%",
          gap: 5,
        }}
      >
        {skeletonCards.map((index) => (
          <>
            <Skeletons
              height={40}
              width={"40px"}
              style={{
                borderRadius: 10,
                marginTop: 6,
              }}
              circle={true}
            />
            <Skeletons
              height={
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? 22
                  : 20
              }
              width={
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? "82px"
                  : "120px"
              }
              style={{
                borderRadius: 50,
                marginTop: 15,
              }}
            />
          </>
        ))}
      </View>
    </View>
  );
};

export default UserListingSkeleton;
